import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function DeleteVersionDialog({ deletingVersion, open, handleDelete }) {
  return (
    <div>
      <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete Version {deletingVersion.version_number}?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Deleting version {deletingVersion.version_number} will re-enable this version for all clients currently in use. {`\n`}
            Are you sure you want to do this?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="contained">
            No
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete} autoFocus>
            Yes, Delete Version {deletingVersion.version_number}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
